import { combineReducers } from 'redux';

import Live from './live/reducers';

export default combineReducers({
    Live,
});

